import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../../../vendorDashboardComponents/navigationSection/RightSideNavigation";
// import { TopNavigationBarMobile } from "../../../../vendorDashboardComponents/navigationSection/TopNavigationBarMobile";
import SeatingDashboard from "./seatingDashboard/SeatingDashboard";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { logOutUser } from "../../../../../store/actions/authAction";
import Media from "react-media";
// import { BottomNavigationMobile } from "../../../../vendorDashboardComponents/navigationSection/BottomNavigationMobile";

export class SuperAdminMainSeatingDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPage: 1,
      status: "All",
    };
  }

  onPageChange = (value) => (e) => {
    this.setState({
      selectedPage: value,
    });
  };

  render() {
    return (
      <React.Fragment>
        <Container fluid>
          <Row>
            <Media query="(min-width: 992px)">
              <div className="left-side-panel">
                <LeftSideNavigation displayLink={1} />
              </div>
            </Media>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="AllSeatingDashboard"
                // actionPerform="button"
                backButtonLink="/superadminseatingall"
                displayText="Back to Super Admin"
              />
              <SeatingDashboard />
            </div>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

SuperAdminMainSeatingDashboard.propTypes = {
  logOutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, { logOutUser })(
  withRouter(SuperAdminMainSeatingDashboard)
);
